import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/export',
    name: 'exportList',
    component: () => import('../pages/ExportListPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
